import { Box } from "@nulogy/components";
import styled from "styled-components";

const LineTypeTag = styled(Box)(({ theme }) => ({
  backgroundColor: theme.colors.white,
  border: `1px solid ${theme.colors.midGrey}`,
  borderRadius: "4px",
  color: theme.colors.midGrey,
  fontSize: theme.fontSizes.smaller,
  fontWeight: theme.fontWeights.normal,
  lineHeight: theme.lineHeights.smallerText,
  marginRight: theme.space.x1,
  padding: "2px 4px",
  width: "max-content",
}));

export default LineTypeTag;
